class CookieStoreShim {
    static isSupported() {
        return typeof window.CookieStore !== 'undefined';
    }

    async get(nameOrOptions) {
        if (CookieStoreShim.isSupported()) {
            return cookieStore.get(nameOrOptions);
        } else {
            const name = typeof nameOrOptions === 'string' ? nameOrOptions : nameOrOptions.name;
            const value = this._getCookie(name);
            return value ? { name, value } : null;
        }
    }

    async getAll(nameOrOptions) {
        if (CookieStoreShim.isSupported()) {
            return cookieStore.getAll(nameOrOptions);
        } else {
            const name = typeof nameOrOptions === 'string' ? nameOrOptions : nameOrOptions.name;
            return this._getAllCookies().filter(cookie => cookie.name === name);
        }
    }

    async set(nameOrOptions, value) {
        if (CookieStoreShim.isSupported()) {
            if (typeof nameOrOptions === 'string') {
                return cookieStore.set({ name: nameOrOptions, value });
            } else {
                return cookieStore.set(nameOrOptions);
            }
        } else {
            if (typeof nameOrOptions === 'string') {
                this._setCookie(nameOrOptions, value);
            } else {
                this._setCookie(nameOrOptions.name, nameOrOptions.value, nameOrOptions);
            }
            return Promise.resolve();
        }
    }

    async delete(nameOrOptions) {
        if (CookieStoreShim.isSupported()) {
            return cookieStore.delete(nameOrOptions);
        } else {
            const name = typeof nameOrOptions === 'string' ? nameOrOptions : nameOrOptions.name;
            this._setCookie(name, '', { expires: -1 });
            return Promise.resolve();
        }
    }

    _getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    _getAllCookies() {
        const cookies = document.cookie.split('; ');
        return cookies.map(cookie => {
            const [name, value] = cookie.split('=');
            return { name, value };
        });
    }

    _setCookie(name, value, options = {}) {
        let attributes = '';
        if (options.expires) {
            const date = new Date(options.expires);
            attributes += `; expires=${date.toUTCString()}`;
        }
        if (options.domain) {
            attributes += `; domain=${options.domain}`;
        }
        if (options.path) {
            attributes += `; path=${options.path}`;
        }
        if (options.sameSite) {
            attributes += `; samesite=${options.sameSite}`;
        }
        document.cookie = `${name}=${value}${attributes}`;
    }
}

window.cookieStoreShim = new CookieStoreShim();
